<div class="scheduler-data">
  <div>
    <div class="group scheduler-start">
      <div class="label"><b>Starts</b></div>
      <div
        class="dateField"
        [ngClass]="{
          'reset-select':
            date.value ||
            (date.invalid &&
              (date.dirty || date.touched) &&
              checkForDate(date.value, inputDate.value)),
          disabled: isDisabledScheduler
        }"
      >
        <mat-form-field appearance="fill">
          <input
            matInput
            #inputDate
            [matDatepicker]="dp"
            [min]="minDate"
            [formControl]="date"
            placeholder="YYYY-MM-DD"
            (dateChange)="onDateChange()"
            [ngClass]="{ disabled: isDisabledScheduler }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dp"
            [disabled]="isDisabledScheduler"
          ></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
        <ng-container
          *ngIf="
            date.value ||
            (date.invalid &&
              (date.dirty || date.touched) &&
              checkForDate(date.value, inputDate.value))
          "
        >
          <i
            (click)="resetScheduler()"
            class="reset material-icons mdi mdi-refresh"
            matTooltip="Reset to now"
            [matTooltipPosition]="'above'"
          ></i>
        </ng-container>
      </div>
      <mat-error
        *ngIf="
          date.invalid && (date.dirty || date.touched) && checkForDate(date.value, inputDate.value)
        "
        >Invalid date</mat-error
      >
    </div>
  </div>
  <div class="scheduler-time" *ngIf="date.value && !checkPrevDate(date.value)">
    <div class="time-width">
      <div class="label"><b>Time</b></div>
      <input
        class="option-list"
        placeholder="HH:MM"
        autocomplete="off"
        (keyup)="editTime()"
        (blur)="editedTimeFormat()"
        [(ngModel)]="time"
      />
    </div>
    <mat-error *ngIf="!validTime"> Invalid time </mat-error>
  </div>
  <div class="repeat-section">
    <div class="group">
      <div class="label"><b>Repeats</b></div>
      <mat-select
        class="option-list"
        [(value)]="selected"
        (selectionChange)="changeRepeat()"
        [disabled]="isDisabledScheduler"
        [ngClass]="{ disabled: isDisabledScheduler }"
      >
        <mat-option *ngFor="let repeat of repeatList" [value]="repeat.value">{{
          repeat.name
        }}</mat-option>
      </mat-select>
    </div>
  </div>
  <div class="end-time" *ngIf="schedulerEnds?.enabled">
    <div class="group">
      <div class="label"><b>Duration *</b></div>
      <mat-select
      class="option-list"
      #endScheduleValInput="ngModel"
      name="endScheduleVal"
      (ngModelChange)="onEndScheduleValChange($event)"
      [(ngModel)]="endScheduleVal"
      required
    >
      <mat-option *ngFor="let opt of durationOptionsList" [value]="opt.value">{{opt.name}}</mat-option>
    </mat-select>
    </div>
    <div class="custom-input-container" *ngIf="endScheduleVal === 'custom'">
      <div class="label">hour:min:sec *</div>
      <input
        matInput
        autocomplete="off"
        type="text"
        class="input-data custom-input"
        name="customScheduleDuration"
        #customScheduleEndsInput="ngModel"
        [(ngModel)]="customScheduleEnds"
        placeholder="HH:MM:SS"
        (ngModelChange)="customScheduleEndsChange()"
        [pattern]="validTestDurationRegex"
        (input)="reformatTestDuration($event)"
        maxlength="8"
        required
      />
      <div class="error"
        *ngIf="customScheduleEndsInput.invalid &&
          (customScheduleEndsInput.dirty || customScheduleEndsInput.touched)">
        <mat-error *ngIf="customScheduleEndsInput?.errors?.required">Duration is required</mat-error>
        <mat-error *ngIf="customScheduleEndsInput.errors?.pattern">Invalid test duration</mat-error>
      </div>
      <div class="error"
        *ngIf="!customScheduleEndsInput.invalid &&
        !isvalidCustomDuration && customDurationErrorMsg">
        <mat-error>{{customDurationErrorMsg}}</mat-error>
      </div>
    </div>
  </div>
</div>
